import { ReactNode } from 'react'
import tw, { TwStyle } from 'twin.macro'

const SVGIcon = ({ children, twStyle }: { children: ReactNode; twStyle?: TwStyle }) => {
  return (
    <div
      css={[tw`flex items-center justify-center rounded-full bg-secondary  p-2 self-center cursor-pointer`, twStyle]}
    >
      {children}
    </div>
  )
}

export default SVGIcon
